import api from './axios';

export const login = (phone, password) => {
  // 只使用手机号登录
  return api.post('/auth/login', { phone, password })
    .then(response => {
      // 检查用户角色是否为DEALER或AGENT
      if (response.data.role !== 'DEALER' && response.data.role !== 'AGENT') {
        throw new Error('您没有权限登录经销商端');
      }

      // 登录成功后保存token和用户信息
      if (response.data.token) {
        try {
          // 同步保存token
          localStorage.setItem('token', response.data.token);

          // 保存用户信息
          const userData = {
            id: response.data.id,
            username: response.data.username,
            phone: response.data.phone,
            fullName: response.data.fullName,
            role: response.data.role
          };
          localStorage.setItem('user', JSON.stringify(userData));

          // 验证保存是否成功
          const savedToken = localStorage.getItem('token');
          const savedUser = localStorage.getItem('user');

          if (!savedToken || !savedUser) {
            throw new Error('登录信息保存失败');
          }

          console.log('登录信息保存成功:', { token: !!savedToken, user: !!savedUser });
        } catch (error) {
          console.error('保存登录信息时出错:', error);
          throw new Error('登录信息保存失败');
        }
      }
      return response;
    });
};

export const register = (userData) => {
  return api.post('/auth/signup', userData);
};

export const resetPassword = (phone) => {
  return api.post('/auth/reset-password', { phone });
};

export const verifyToken = () => {
  return api.get('/auth/verify');
};

export const changePassword = (oldPassword, newPassword) => {
  return api.put('/user/password', { oldPassword, newPassword });
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.href = '/login';
}; 
